var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sun",
    clipPath: "url(#clip0_1981_3746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.359 10.286C16.359 13.7976 13.5118 16.6444 10.0009 16.6444C6.49012 16.6444 3.64209 13.7976 3.64209 10.286C3.64209 6.77477 6.49012 3.92725 10.0009 3.92725C13.5118 3.92725 16.359 6.77477 16.359 10.286Z",
    fill: "#FFCE31"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.0007 16.7823C6.41827 16.7823 3.50391 13.8681 3.50391 10.2861C3.50391 6.70351 6.41827 3.78931 10.0007 3.78931C13.5827 3.78931 16.4966 6.70351 16.4966 10.2861C16.4966 13.8681 13.5827 16.7823 10.0007 16.7823ZM10.0007 4.50354C6.81226 4.50354 4.21813 7.09783 4.21813 10.2861C4.21813 13.4741 6.81226 16.0681 10.0007 16.0681C13.1887 16.0681 15.7823 13.4741 15.7823 10.2861C15.7823 7.09783 13.1887 4.50354 10.0007 4.50354Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20 10.6435H18.1108V9.92896H20V10.6435Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.88898 10.6435H0V9.92896H1.88898V10.6435Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.3962 2.17426H9.68213V0.286133H10.3962V2.17426Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4.05793 5.13527L2.73535 3.81152L3.24081 3.3064L4.56338 4.63015L4.05793 5.13527Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M15.9431 5.13527L15.438 4.63015L16.76 3.3064L17.2652 3.81152L15.9431 5.13527Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M10.3962 20.286H9.68213V18.3972H10.3962V20.286Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M3.24081 17.2656L2.73535 16.7605L4.05793 15.4368L4.56338 15.9419L3.24081 17.2656Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M16.76 17.2656L15.438 15.9419L15.9431 15.4368L17.2652 16.7605L16.76 17.2656Z",
    fill: "#37474F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1981_3746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.286133)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.193bca3f24549912e3c1905835057ea5.svg";
export { ForwardRef as ReactComponent };